module.exports = __webpack_public_path__ + "static/img/btn4.23aca1cb.png";